module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Velg fremtidsferdighetene som interesserer deg mest","subtitle":"Velg favorittene dine fra de 10 anbefalte","nextButton":"Neste"},"en":{"title":"Velg fremtidsferdighetene som interesserer deg mest","subtitle":"Choose your favorites from the 10 essentials","nextButton":"Next"}}')
  delete Component.options._Ctor
}
